import { Bar } from "vue-chartjs";

export default {
  extends: Bar,
  props: {
    chartdata: {
      type: Object,
      default: null
    },
    options: {
      type: Object,
      default: null
    }
  },
  mounted() {
    this.renderChart(this.chartdata, this.cOptions);
  },
  computed: {
    cOptions() {
      const drawTotals = chart => {
        const ctx = chart.ctx;

        chart.data.labels.forEach((label, i) => {
          let total = chart.data.datasets.reduce((acc, curr, index) => {
            const meta = chart.getDatasetMeta(index);
            if (!meta.hidden) {
              acc += curr.data[i];
            }
            return acc;
          }, 0);

          let lastMeta = null;
          for (let j = chart.data.datasets.length - 1; j >= 0; j--) {
            const meta = chart.getDatasetMeta(j);
            if (!meta.hidden) {
              lastMeta = meta;
              break;
            }
          }
          if (!lastMeta) {
            return;
          }

          const bar = lastMeta.data[i];
          if (!bar?._model) {
            return;
          }

          const { x, y } = bar._model;

          ctx.save();
          ctx.fillStyle = "#000";
          ctx.font = "bold 12px Arial";
          ctx.textAlign = "center";
          ctx.fillText(total, x, y - 5);
          ctx.restore();
        });
      };

      return {
        ...this.options,
        animation: {
          duration: 600,
          easing: "easeOutCubic",
          onComplete: function() {
            drawTotals(this.chart);
          }
        },
        hover: {
          animationDuration: 0
        },
        legend: {
          onClick: function(e, legendItem) {
            const chart = this.chart;
            const index = legendItem.datasetIndex;
            const meta = chart.getDatasetMeta(index);
            meta.hidden =
              meta.hidden === null ? !chart.data.datasets[index].hidden : null;

            chart.update({
              duration: 600,
              easing: "easeOutCubic"
            });
            setTimeout(() => drawTotals(chart), 0);
          }
        },
        scales: {
          xAxes: [{ stacked: true }],
          yAxes: [{ stacked: true }]
        },
        tooltips: {
          mode: "index",
          intersect: false,
          callbacks: {
            label: function(tooltipItem, data) {
              const ds = data.datasets[tooltipItem.datasetIndex];
              const value = ds.data[tooltipItem.index];
              return `${ds.label}: ${value}`;
            }
          }
        }
      };
    }
  },
  methods: {
    render() {
      this.renderChart(this.chartdata, this.cOptions);
    }
  },
  watch: {
    chartdata: {
      deep: true,
      handler() {
        this.render();
      }
    }
  }
};
